import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import AppProvider from "@/providers/index.tsx";
import { ErrorBoundary } from "@/components/common/ErrorBoundary";

createRoot(document.getElementById("root")!).render(
    <StrictMode>
        <AppProvider>
            <ErrorBoundary>
                <App />
            </ErrorBoundary>
        </AppProvider>
    </StrictMode>
);
